module.exports = __webpack_public_path__ + "img/akanksha.bc43a26d.jpg";